import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import {
  approveApproval,
  approveApprovals,
  listApprovals,
  rejectApproval,
  rejectApprovals,
} from '../../../redux/atlasai/actions'
import { approvalsResolving, pendingApprovals } from '../../../redux/atlasai/selectors'
import { createConnector, InferConnectedProps } from '../../../redux/createConnector'
import { putNotification } from '../../../redux/ui/actions'
import PendingApprovals, { IProps } from './PendingApprovals'

const selector = createStructuredSelector({
  pending: pendingApprovals,
  resolving: approvalsResolving,
})

const actions = {
  listApprovals,
  approveApproval,
  rejectApproval,
  approveApprovals,
  rejectApprovals,
  putNotification,
}

const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>

export default createConnector<typeof connector, IProps, PropsFromRedux>(
  connector,
  PendingApprovals,
)
